var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLangIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.617,
    height: 31,
    viewBox: "0 0 33.617 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44875",
    "data-name": "Group 44875",
    transform: "translate(-4.192 -2.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44884",
    "data-name": "Group 44884",
    transform: "translate(3.22 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39991",
    "data-name": "Path 39991",
    d: "M120.618,192.3a.131.131,0,0,1,.01.065l-.069-.018.06-.047",
    transform: "translate(-113.71 -178.062)",
    fill: "#6993eb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7581",
    "data-name": "Ellipse 7581",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(15.589 12.727)",
    fill: "#fff7ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7582",
    "data-name": "Ellipse 7582",
    transform: "translate(2.589 0.727)",
    fill: "#fff7ed",
    stroke: "#ffd8a3",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39997",
    "data-name": "Path 39997",
    d: "M10.56,0h1.9L7.22-13.78H5.3L.06,0h1.9L3.3-3.54H9.22ZM3.9-5.14l2.36-6.24L8.62-5.14Z",
    transform: "translate(20.59 24.728)",
    fill: "#ed941a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39998",
    "data-name": "Path 39998",
    d: "M2.275-8.633q.146.459.342,1a11.1,11.1,0,0,0,.464,1.094,9.9,9.9,0,0,0,.605,1.069,4.806,4.806,0,0,0,.771.918,3.619,3.619,0,0,0,.962.64,2.8,2.8,0,0,0,1.172.239,2.762,2.762,0,0,0,1.074-.186,1.921,1.921,0,0,0,.713-.5,1.9,1.9,0,0,0,.4-.732A3.133,3.133,0,0,0,8.9-5.967a1.881,1.881,0,0,0-.728-1.572,3.37,3.37,0,0,0-2.1-.566q-.166,0-.332.01T5.4-8.066V-9.551a1.151,1.151,0,0,0,.142.01h.073a3.974,3.974,0,0,0,1.216-.171,2.726,2.726,0,0,0,.894-.464,1.957,1.957,0,0,0,.547-.684,1.889,1.889,0,0,0,.186-.82,1.668,1.668,0,0,0-.137-.693,1.466,1.466,0,0,0-.371-.508,1.545,1.545,0,0,0-.557-.308,2.308,2.308,0,0,0-.7-.1,3.661,3.661,0,0,0-.508.034,4.325,4.325,0,0,0-.518.107,6,6,0,0,0-.581.19q-.308.117-.7.293L3.828-14a8.337,8.337,0,0,1,1.465-.562,5.467,5.467,0,0,1,1.436-.19,3.693,3.693,0,0,1,1.3.225,3.167,3.167,0,0,1,1.035.62,2.806,2.806,0,0,1,.679.942,2.865,2.865,0,0,1,.244,1.182A3.216,3.216,0,0,1,8.32-8.975v.039a3.758,3.758,0,0,1,1.094.674q.283.049.6.078t.581.029a4.509,4.509,0,0,0,.576-.039,3.22,3.22,0,0,0,.62-.146,3.368,3.368,0,0,0,.645-.3A3.856,3.856,0,0,0,13.1-9.15v-5.41h3.652v1.436H14.7V0H13.1V-7.422l-.039-.01a3.315,3.315,0,0,1-1.045.488,4.3,4.3,0,0,1-1.006.117q-.166,0-.342-.015T10.3-6.875l-.01.039a2.725,2.725,0,0,1,.156.986,3.985,3.985,0,0,1-.264,1.465,3.362,3.362,0,0,1-.757,1.167,3.429,3.429,0,0,1-1.191.767,4.268,4.268,0,0,1-1.567.273A4.133,4.133,0,0,1,5-2.5,5.319,5.319,0,0,1,3.647-3.35,6.163,6.163,0,0,1,2.6-4.517a10.278,10.278,0,0,1-.771-1.3A10.988,10.988,0,0,1,1.3-7.065q-.205-.591-.3-.981Z",
    transform: "translate(-0.024 15.728)",
    fill: "#ed941a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangIcon);
export default __webpack_public_path__ + "static/media/lang-icon.0c7707d7f5d796720180a606807d77bd.svg";
export { ForwardRef as ReactComponent };